var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2344 2.85938C24.9531 1.73438 24.0625 0.84375 22.9844 0.5625C20.9688 0 13 0 13 0C13 0 4.98438 0 2.96875 0.5625C1.89062 0.84375 1 1.73438 0.71875 2.85938C0.15625 4.82812 0.15625 9.04688 0.15625 9.04688C0.15625 9.04688 0.15625 13.2188 0.71875 15.2344C1 16.3594 1.89062 17.2031 2.96875 17.4844C4.98438 18 13 18 13 18C13 18 20.9688 18 22.9844 17.4844C24.0625 17.2031 24.9531 16.3594 25.2344 15.2344C25.7969 13.2188 25.7969 9.04688 25.7969 9.04688C25.7969 9.04688 25.7969 4.82812 25.2344 2.85938ZM10.375 12.8438V5.25L17.0312 9.04688L10.375 12.8438Z",
    fill: "#FEFEFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.cf838d740b9c9c50a8363de3515f2661.svg";
export { ForwardRef as ReactComponent };